import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "store/actions";
import { State } from "store/reducers";
import ls from "Localization";
import { Grid, Typography, Container, CircularProgress } from "@mui/material";
import TotalPeople from "./Totalpeople";
import { HomeDashboardState } from "store/reducers/home";
import { isInRole } from "helpers/auth";

function Dashboard() {
    const dispatch = useDispatch<any>();

    const { dashboardData, loading } = useSelector<State, HomeDashboardState>(
        state => state.dashboard
    );
    const { user } = useSelector<State, any>(state => state.login);

    useEffect(() => {
        dispatch(actions.dashboard.getDashboard());
    }, [dispatch]);

    if (loading) {
        return (
            <Container
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh"
                }}
            >
                <CircularProgress />
            </Container>
        );
    }

    const { users, meis, meisOverDue, overdueDas, overdueDasn } = dashboardData || {};

    const totalUsers = users ? users.total : 0;
    const totalMeis = meis ? meis.total : 0;
    const meisOk = meisOverDue || 0;
    const totalDasOverDue = overdueDas ? overdueDas.total : 0;
    const totalDasnOverDue = overdueDasn ? overdueDasn.total : 0;

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                Dashboard
            </Typography>
            <Grid container spacing={3}>
                {isInRole(user, ["admin"]) && (
                    <TotalPeople
                        title={ls.TotalUsers}
                        count={totalUsers}
                    />
                )}
                <TotalPeople
                    title={ls.TotalMeis}
                    count={totalMeis}
                />
                <TotalPeople title={ls.MEIsOk} count={meisOk} />
                <TotalPeople
                    title={ls.TotalDasOverDue}
                    count={totalDasOverDue}
                />
                <TotalPeople
                    title={ls.TotalDasnOverDue}
                    count={totalDasnOverDue}
                />
            </Grid>
        </Container>
    );
}

export default Dashboard;
